<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <div class="source-bib-info">
    <!-- TODO: Change info related to add/edit -->
    <p>
      {{ 'Collega una fonte con il bene corrente.' | translate }}
    </p>
    <p>
      {{ 'Una volta collegato dovrai salvare le modifiche apportate' | translate }}
    </p>
  </div>

  <form [formGroup]="sourceBibForm">
    <mat-horizontal-stepper linear>
      <mat-step [label]="'Seleziona fonte' | translate">
        <ui-table
          [rowSelection]="'single'"
          [fields]="fields"
          [pager]="pager$"
          [filters]="filters$ | async"
          [reload]="reload$"
          [itemsPage]="(page$ | async)?.current"
          [itemsPerPage]="(page$ | async)?.limit"
          [selected]="selectedItems"
          (select)="selectHandler($event)"
          (itemsPageChange)="applyChangePageHandler($event)">
          <div tableFilters>
            <ui-filters
              [dialogFilters]="MobileFiltersComponent"
              (action)="applyFilterWithDelayHandler($event)">
              <app-source-bibliographic-filters #desktopFilter></app-source-bibliographic-filters>
            </ui-filters>
          </div>
        </ui-table>
        <div class="source-bib-actions">
          <button
            mat-button
            mat-raised-button
            matStepperNext
            type="button">
            {{ 'Continua' | translate }}
          </button>
        </div>
      </mat-step>
      <mat-step [label]="'Aggiungi info' | translate">
        <mat-form-field>
          <input
            formControlName="riferimento"
            matInput
            [placeholder]="'Riferimento' | translate">
        </mat-form-field>
        <ng-container *ngIf="sourceBibForm.controls.riferimento?.touched">
          <mat-error
            *ngIf="sourceBibForm.controls.riferimento?.hasError('required')"
            class="message-error">
            {{ 'Riferimento obbligatorio' | translate }}
          </mat-error>
        </ng-container>
        <div class="source-bib-actions">
          <button
            mat-button
            mat-raised-button
            matStepperPrevious
            type="button">
            {{ 'Indietro' | translate }}
          </button>
          <button
            mat-button
            mat-raised-button
            type="button"
            (click)="completeHandler()">
            {{ mainActionLabel }}
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </form>
</mat-dialog-content>
